// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dN8wDr4E3_EK0TcKZrpn{margin-top:-30px}.lSuYeuWQAB8K4w7phgKs{flex-direction:column;display:flex}.fwjtqbduGU8cg9WY4cL_{flex-direction:column;gap:4px;padding:8px 0;display:flex}.fwjtqbduGU8cg9WY4cL_:empty{display:none}.KyO6971deoEPvvP1REEt{margin:20px 0 3px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `dN8wDr4E3_EK0TcKZrpn`,
	"message": `lSuYeuWQAB8K4w7phgKs`,
	"alerts": `fwjtqbduGU8cg9WY4cL_`,
	"tabs": `KyO6971deoEPvvP1REEt`
};
export default ___CSS_LOADER_EXPORT___;
